module.exports = __webpack_public_path__ + "img/client_notice.38a1b057.svg";